import { initializeCaptionExpansion } from './caption-expansion.ts';
import { initializeShowMore } from './show-more.ts';
import './styles.scss';

initializeCaptionExpansion();
initializeShowMore();
